import React, { FC } from 'react';
import AdminDocumentDeletedRequest from '../../components/core/AdminDocumentDeleteRequest/AdminDocumentDeletedRequest';
import PrimaryNavigation from '../../components/core/PrimaryNavigation/PrimaryNavigation';
interface AdminRequestDocumentProps {}
import  './AdminRequestDocument.css';
const AdminRequestDocument : FC<AdminRequestDocumentProps > = () => (
  <div className="AdminRequestDocumentDeleted">
  <PrimaryNavigation />
  <div className="container-deleted">
 <AdminDocumentDeletedRequest></AdminDocumentDeletedRequest>
  </div>
</div>
);

export default AdminRequestDocument;